module.exports = __webpack_public_path__ + "img/indonesian_logo.78082186.svg";